export const enum Medal {
  Gold = "gold",
  Silver = "silver",
  Bronze = "bronze"
}
